import { render, staticRenderFns } from "./ReadAgreementByLegal.vue?vue&type=template&id=32816e2d&"
import script from "./ReadAgreementByLegal.vue?vue&type=script&lang=js&"
export * from "./ReadAgreementByLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports